import { Grid } from '@mui/material';

const InfoRow = ({
  title,
  value,
  mb = 0,
  alignItems = 'left',
  postfix,
  component,
  fullWidth,
}) => {
  if (title) {
    return (
      <Grid
        item
        xs={12}
        spacing={1}
        container
        sx={{ pb: 0, mb }}
        alignItems={alignItems}
      >
        <Grid item xs={fullWidth ? 12 : 4}>
          <strong>{title}:</strong>
        </Grid>
        {component ? (
          component
        ) : (
          <Grid item xs={fullWidth ? 12 : 8}>
            {`${value} ${postfix || ''}`}
          </Grid>
        )}
      </Grid>
    );
  }
  return (
    <Grid item xs={12} spacing={1} container sx={{ pb: 0, mb }}>
      <Grid item xs={12}>
        {value}
      </Grid>
    </Grid>
  );
};

export default InfoRow;
